import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    openEnd: {
        color: ({ theme }) => Mixins.foregroundColor(theme, Mixins.controlBackgroundColor(theme)),
        composes: "open-end",
        margin: ({ gridRendering }) => [[12, gridRendering ? "auto" : 0]],
        maxWidth: ({ theme, size }) => Mixins.inputMaxWidth(theme, size, "Full"),
        minWidth: ({ theme, size }) => Mixins.inputMinWidth(theme, size, "Full"),
    },
    openEndError: {
        composes: "open-end--error",
    },
});
